import React from 'react';
export function Footer() {
  return <footer className="w-full bg-sage-dark" data-id="element-101" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-102" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl text-ochre-soft" data-id="element-103" data-mp="3ghc2o28413o8">
          Breathwork Session Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-cream/70" data-id="element-104" data-mp="32m1cv38q38qq">
          The Breath Arc Method — so you never build a breath session from a
          blank page again.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-cream/70" data-id="element-105" data-mp="3ucxo5zf4x5bw">
          <a href="mailto:help@iclcollective.com" className="hover:text-cream hover:underline" data-id="element-106" data-mp="36mr0ed8wopu">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-sage-line pt-5 text-xs leading-relaxed text-cream/45" data-id="element-107" data-mp="3qcdp2qb03rn4">
          Breathwork Session Ready is a professional resource for trained
          conscious connected breathwork facilitators working with adults. It
          supports your training and judgment; it does not teach breathwork
          from scratch and does not replace your training, professional
          insurance, medical advice or your legal obligations. It is not a
          treatment, makes no health claims and no outcome is guaranteed.
          Case examples are composites with no real client data. Not
          affiliated with or endorsed by any breathwork school, training body,
          association or method. &copy; Breathwork Session Ready 2026 — All
          rights reserved.
        </p>
      </div>
    </footer>;
}